import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectVideosTransactions } from 'app/selectors/ugc/VideosSelector';
import VideosActions from 'app/actions/VideosActions';
import ModalActions from 'app/actions/ModalActions';
import DeleteVideoModal from './DeleteVideoModal';

export class DeleteVideoModalContainer extends React.PureComponent {
  render() {
    return <DeleteVideoModal {...this.props} />;
  }
}

DeleteVideoModalContainer.propTypes = {
  // ownProps
  videoId: PropTypes.number.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleSuccess: PropTypes.func,

  // Redux props
  videosActions: PropTypes.objectOf(PropTypes.func).isRequired,
  videosTransactions: ImmutablePropTypes.map.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = state => ({
  videosTransactions: selectVideosTransactions(state)
});

const mapDispatchToProps = dispatch => ({
  videosActions: bindActionCreators(VideosActions, dispatch),
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteVideoModalContainer);
